//import React, { useState, useEffect } from "react";
import LogoAnimation from "./firstscreen";

const ShapeTracingApp = () => {
 
  return (
    <div>
    <LogoAnimation/> 
    <div className="min-h-screen bg-gradient-to-br from-purple-900 via-blue-900 to-indigo-900">
      <div className="container mx-auto px-4 py-8">
        
        <div className="text-center mb-8">
          <h1 className="text-5xl font-bold text-white mb-4">
            First Demo Deploy
          </h1>
          </div>
        </div>
      </div>
      </div>
  );
};

export default ShapeTracingApp;